import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import React from 'react';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import { MyMImage } from '../../ui-elements/MyMImage';
import { NavigateLink } from '../../ui-parts/NavigateLink';

const StandardPageTopBar = (props) => {
  const { screenId, controlSettings} = props;
  const isPc = useMediaQuery(mediaQuery.pc);

  return (
    <Grid container justifyContent="flex-start" alignItems="center" style={{ paddingBottom: '3px' }}>
      <Grid item xs={3} md={3} sx={{ '>img': { width: { xs: '100%', md: 'auto' }, maxWidth: { xs: 180 } } }}>
        <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgHITACHI} />
      </Grid>
      {isPc ? 
        <>
          <Grid item md={6} className="h-100 d-flex align-items-center justify-content-center" >
            <NavigateLink to="/MyM102">
              <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgLogo} height='110px' width='350px' />
            </NavigateLink>
          </Grid>
        </>
        :
        <>
          <Grid item xs={12} className="h-100 d-flex justify-content-center" >
            <Link href={process.env.PUBLIC_URL + "/MyM102"}>
              <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgLogo} style={{height: '100%',maxHeight: '110px',width: '100%',maxWidth: '350px',}} />
            </Link>
          </Grid>
        </>
       }
    </Grid>
  );
}

export default StandardPageTopBar;
